<template>
    <v-content >
      <section >
        <v-parallax img :src="require('@/assets/SBF2019_Setup_2500x1500.jpg')" height="500">
          <v-layout
            column
            align-center
            justify-center
            class="white--text"
          >
          <div class="headline text-lg-center black--text" v-if="($vuetify.breakpoint.smAndDown)">
            <img :src="require('@/assets/BeachFest 2020_Web_Alpha-Light.png')" alt="Beachfest Logo" height="220">
            <h1><b>Scottsdale BeachFest</b></h1>
          </div>
          <div v-else>
              <div style="display: inline-block;background-color:rgba(205,205,205,.5);border:solid thin #222;margin-bottom:10px;">
                  <img :src="require('@/assets/BeachFest 2020_Web_Alpha-Light.png')" alt="Beachfest Logo" height="220">
              </div>
          </div>
          <div>
            <v-btn color="#ff8414" to="/volunteers"
              dark
              large
              rounded
            >
              Volunteers
            </v-btn>
            <v-btn color="#00843d" to="/events"
              dark
              large
              rounded
            >
              Events
            </v-btn>
            <v-btn color="#0374fc"
                    to="/calendar"
              dark
              large
              rounded
            >
              2020 Calendar
            </v-btn>
          </div>
         </v-layout>
        </v-parallax>

        <v-container fluid  grid-list-lg-center  color="#000000" ma-0 pa-0>

            <!--HERO TEXT-->
              <v-layout row wrap>
                  <v-flex xs12>
                      <v-card class="elevation-0 white--text" color="#000000">
                          <v-card-title primary-title class="layout justify-center">
                              <div class="headline text-lg-center">Air-Conditioned Beach Volleyball In Arizona!!</div>
                          </v-card-title>
                          <v-card-text class="layout center font-weight-thin subheading white--text pl-6">
                              The 2nd-Annual Scottsdale BeachFest offers hands-down the world's most UNIQUE venue in Beach Volleyball. Players and spectators alike will enjoy the air-conditioned comfort of the Equidome arena in North Scottsdale @ WestWorld.  Festival features 16 event-filled days of beach volleyball tournaments, camps, clinics, training on 12 professionally constructed beach courts.  Players will enjoy the cool climate, deep sand, quality net systems, and high ceilings.  Spectators can watch action from arena seating areas, visit on-site exhibitors, enjoy food/drink options, and shop at the BeachFest Store. You won’t want to miss this!
                          </v-card-text>
                      </v-card>
                  </v-flex>
              </v-layout>

        </v-container>

		</section>

        <v-container fluid>
            <v-layout row wrap align-top >

                <v-flex xs12 md4 pa-2>
                    <div class="crdbd">
                        <v-card to="" dark  color="black" @click="openwindow('https://p1440.volleyballlife.com/tournament/688')" >
                            <v-card-title primary-title class="layout justify-center">
                                <img :src="require('@/assets/p1440_logo.png')" alt="P1440 Logo" height="60">
                            </v-card-title>
                            <v-card-text class="text--lighten-1">
                                {{p1440text}}
                            </v-card-text>
                        </v-card>
                    </div>
                </v-flex>

                <v-flex xs12 md4 pa-2>
                    <div class="crdbd">
                        <v-card dark color="black">
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline">
                                    <v-icon class="pl-3" color="orange darken-2">mdi-map-marker</v-icon>
                                    Event Location
                                </div>
                            </v-card-title>
                            <v-list class="transparent white--text">
                                <v-list-item>
                                <v-list-item @click="openwindow('https://goo.gl/maps/Z3HEDHWFwuyju2Np9')">
                                    <v-list-item-action>
                                        <v-icon>map-marker</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        16601 N Pima Rd, Scottsdale, AZ 85260
                                    </v-list-item-content>
                                </v-list-item>
                                </v-list-item>
                                <v-list-item>
                                <v-list-item @click="openwindow('https://www.westworldaz.com/')">
                                    <v-list-item-action>
                                        <v-icon>fas fa-link</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        https://www.westworldaz.com/
                                    </v-list-item-content>
                                </v-list-item>
                                </v-list-item>
                            </v-list>
                            <v-card-text class="layout justify-center">
                            </v-card-text>
                        </v-card>
                    </div>
                </v-flex>

                <v-flex xs12 md4 pa-2>
                    <div class="crdbd">
                        <v-card dark  color="black">
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline">
                                    <v-icon class="pl-3" color="green darken-2">fas fa-info</v-icon>
                                    Contact Us
                                </div>
                            </v-card-title>
                            <v-list class="transparent white--text">
                                  <v-list-item>
                                <v-list-item @click="openwindow('mailto:info@scottsdalebeachfest.com')">
                                    <v-list-item-action>
                                        <v-icon class="blue--text text--lighten-2">mdi-email</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>info@scottsdalebeachfest.com</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                </v-list-item>
                                <v-list-item>
                                <v-list-item @click="openwindow('https://instagram.com/scottsdalebeachfest')">
                                    <v-list-item-action>
                                        <v-icon class="blue--text text--lighten-2">mdi-instagram</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>@scottsdalebeachfest</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                </v-list-item>
                                <v-list-item>
                                <v-list-item @click="openwindow('https://facebook.com/scottsdalebeachfest')">
                                    <v-list-item-action>
                                        <v-icon class="blue--text text--lighten-2">mdi-facebook</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>facebook/scottsdalebeachfest</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>

    </v-content>
</template>

<script>
  export default {
    data: () => ({
    title: 'Beachfest',
      p1440text:'2-day Launch Event Jan 13th/14th features State Qualifier event 12u/14u/16u/18u Club Division and Elite Level 16u/18u Divisions. Air-conditioned arena, deep sand, pro nets, high ceilings and amazing atmosphere. Registration OPEN NOW '
    }),
      methods:{
          openwindow: function(url){
              window.open(url, '_blank');
          }
      }
  }
</script>

<style>
    .crdbd{
        border:solid thin #BBB;
        border-radius: 3px;
        height:275px;
    }
</style>
